import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/crayon-1.svg';
export default {
  name: 'GlobalArticleCard',
  props: {
    slug: {
      type: String,
      required: true
    },
    image: {
      type: Object,
      required: true
    },
    tags: {
      type: Array,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    readingTime: {
      type: Number,
      required: true
    },
    difficulty: {
      type: Number,
      required: true
    },
    colorBorder: {
      type: String,
      default: '#fff'
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  methods: {
    formatArticleUrl: function formatArticleUrl(arg) {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/e/article/").concat(arg);
    },
    formatDate: function formatDate(arg) {
      var date = new Date(arg);
      var locale = "".concat(this.locale.language, "-").concat(this.locale.market);
      var options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      };
      return date.toLocaleDateString(locale, options);
    }
  }
};